/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from "react";

export interface IScrollToMenuItemProps {
  userOrder: any;
  refs: { [key: string]: React.RefObject<HTMLDivElement> };
  scrollOffSet?: number;
  // @ts-ignore Upgrade to React 18
  children?: any;
}

export default class ScrollToMenuItem extends React.Component<
  IScrollToMenuItemProps,
  any
> {
  // @ts-ignore - Project Upgrade
  smoothScrollClear: Function;

  componentWillUnmount() {
    if (this.smoothScrollClear) {
      this.smoothScrollClear();
    }
  }

  render() {
    return this.props.children;
  }
}
